const frameworkTables = new Set([
    'cache',
    'cache_locks',
    'failed_jobs',
    'job_batches',
    'jobs',
    'migrations',
    'password_reset_tokens',
    'personal_access_tokens',
    'sessions',
    'users',
]);
/** Reserve Laravel's tables when constructing or editing an enriched model. */
export function validateFrameworkTable(table, modelName) {
    if (modelName === 'User' && table.toLowerCase() === 'users')
        return;
    if (frameworkTables.has(table.toLowerCase())) {
        throw new FrameworkTableCollisionError(`Table "${table}" used by model "${modelName}" is reserved for Laravel infrastructure. Choose a different table name.`);
    }
}
export class FrameworkTableCollisionError extends Error {
}
